import dayjs from 'dayjs';

const isDev = process.env.NODE_ENV === 'development';

declare module 'dayjs' {
  interface Dayjs {
    /**
     * YYYY.MM.DD 형태로 날짜를 표현합니다.
     */
    aimsDate: string;
    periodDate: string;

    /**
     * YYYY-MM-DD 형태로 날짜를 표현합니다.
     */
    aclosetDate: string;
    dashDate: string;

    /**
     * 사람이 읽는 '월' 표시를 합니다. (1~12월)
     *
     * @returns month() + 1
     */
    humanMonth: number;
  }
}

declare global {
  interface String {
    /**
     * 문자열을 dayjs 타입으로 바꿉니다.
     *
     * @returns dayjs(this)
     */
    dayjs: dayjs.Dayjs;

    /**
     * @link dayjs.Dayjs.aimsDate
     */
    aimsDate: string;
    periodDate: string;
    periodShortDate: string;

    /**
     * @link dayjs.Dayjs.aclosetDate
     */
    aclosetDate: string;
    dashDate: string;
  }

  interface Number {
    /**
     * 숫자를 unix time '초(sec)' 로 고려하여 변환합니다.
     *
     * @returns dayjs.unix(this)
     */
    dayjs: dayjs.Dayjs;

    /**
     * 숫자를 unix time '밀리초(milli-sec)' 로 고려하여 변환합니다.
     *
     * @returns dayjs(this)
     */
    dayjsMs: dayjs.Dayjs;
  }
}

/**
 * AIMS 에서 자주 쓰는 날짜 포맷 확장.
 */
export const aclosetDayjsPlugin: dayjs.PluginFunc = (option, dayjsClass) => {
  Object.defineProperties(dayjsClass.prototype, {
    aimsDate: {
      get() {
        return this.format('YYYY.MM.DD');
      },
      configurable: isDev,
    },

    periodDate: {
      get() {
        return this.format('YYYY.MM.DD');
      },
      configurable: isDev,
    },

    aclosetDate: {
      get() {
        return this.format('YYYY-MM-DD');
      },
      configurable: isDev,
    },

    dashDate: {
      get() {
        return this.format('YYYY-MM-DD');
      },
      configurable: isDev,
    },

    humanMonth: {
      get() {
        return this.month() + 1;
      },
      configurable: isDev,
    },
  });
};

/**
 * 문자열에 대해 dayjs 플러그인 활성화.
 */
export const enableDayjsPlugin = () => {
  Object.defineProperties(String.prototype, {
    dayjs: {
      get() {
        return dayjs(this);
      },
      configurable: isDev,
    },

    aimsDate: {
      get() {
        return this.dayjs.aimsDate;
      },
      configurable: isDev,
    },

    aclosetDate: {
      get() {
        return this.dayjs.aclosetDate;
      },
      configurable: isDev,
    },
  });

  Object.defineProperties(Number.prototype, {
    dayjs: {
      get() {
        return dayjs.unix(this);
      },
      configurable: isDev,
    },

    dayjsMs: {
      get() {
        return dayjs(this);
      },
      configurable: isDev,
    },
  });
};
